import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getBuilding(
  pathname,
  queryParams = "",
  extraHeaders = {},
) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers: extraHeaders,
  });
}

export async function createBuilding(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/building" + pathname, body);
}

export async function updateBuilding(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/building" + pathname, body);
}

export async function deleteBuilding(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/building" + pathname, { data: body });
}
